@if (!!messageValue.length) {
  @for (item of messageValue; track $index) {
    <p-message
      [text]="item?.detail"
      [icon]="item?.icon"
      [severity]="item?.severity"
      [showTransitionOptions]="'0ms'"
      [hideTransitionOptions]="'0ms'"
      [closable]="true"
      (onClose)="messageValue = []" />
  }
}

<microsec-card>
  <div style="max-width: 50rem">
    <microsec-form-builder
      [isPage]="true"
      #fb
      [fields]="fields"
      [shouldShowActionButtons]="true"
      [submitButtonLabel]="''"
      [cancelButtonLabel]="''"
      (submitEvent)="onSubmit()"
      [leftActionArea]="permissions[USER_ROLE.TECHNICIAN] ? leftActionArea : null" />
  </div>
</microsec-card>

<ng-template #enabledTemplate>
  <ng-container
    *ngIf="
      !!form &&
      !!form?.form &&
      !!form?.form?.get([FORM_PARAMS.ENABLED, FORM_PARAMS.PACKAGES]) &&
      !!form?.form?.get([FORM_PARAMS.ENABLED, FORM_PARAMS.CONFIGURATIONS]) &&
      !!form?.form?.get([FORM_PARAMS.ENABLED, FORM_PARAMS.FIRMWARES]) &&
      !!form?.form?.get([FORM_PARAMS.ENABLED, FORM_PARAMS.PROTOCOLS])
    "
    [formGroup]="$any(form.form)">
    <ng-container [formGroupName]="FORM_PARAMS.ENABLED">
      <div class="grid grid-cols-12 gap-2">
        <div class="col-span-6 flex flex-col gap-2">
          <label class="font-bold">Enabled Vulnerability Types</label>
          <label class="text-grey">Select the vulnerability types to be enabled on MicroIDS</label>
        </div>
        <div class="col-span-6">
          <div class="flex flex-col gap-2">
            <div class="flex items-center">
              <p-checkbox [binary]="true" [formControlName]="FORM_PARAMS.CONFIGURATIONS" />
              <label class="ml-2 pt-2">Configuration</label>
            </div>
            <div class="flex items-center">
              <p-checkbox [binary]="true" [formControlName]="FORM_PARAMS.FIRMWARES" />
              <label class="ml-2 pt-2">Firmware</label>
            </div>
            <div class="flex items-center">
              <p-checkbox [binary]="true" [formControlName]="FORM_PARAMS.PACKAGES" />
              <label class="ml-2 pt-2">Package</label>
            </div>
            <div class="flex items-center">
              <p-checkbox [binary]="true" [formControlName]="FORM_PARAMS.PROTOCOLS" />
              <label class="ml-2 pt-2">Protocol</label>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </ng-container>
</ng-template>

<ng-template #frequencyTemplate>
  @if (!!form && !!form.form) {
    <ng-container [formGroup]="form.form">
      <div class="grid grid-cols-12 gap-2">
        <label class="col-span-12 font-bold mb-2">Vulnerability Scan Frequency</label>
        <div class="col-span-6">
          <label class="text-grey">Set a schedule to initiate a vulnerability scan automatically</label>
        </div>
        <div class="col-span-6 flex flex-col gap-2">
          <p-select
            [options]="SYNC_FREQUENCY_OPTIONS"
            [formControlName]="FORM_PARAMS.SCAN_FREQUENCY"
            placeholder="Select frequency"
            optionLabel="label"
            optionValue="value"
            appendTo="body" />
        </div>
      </div>
    </ng-container>
  }
</ng-template>

<ng-template #connectionsTemplate>
  @if (!!form && !!form.form) {
    <ng-container [formGroup]="form.form">
      <div class="grid grid-cols-12 gap-2">
        <label class="col-span-12 font-bold mb-2">Network Connection</label>
        <div class="col-span-6">
          <label class="text-grey">Select network connection(s) for vulnerability analyzer to scan</label>
        </div>
        <div class="col-span-6 flex flex-col gap-2">
          <p-multiSelect
            appendTo="body"
            [options]="connectionOptions"
            [formControlName]="FORM_PARAMS.CONNECTION_IDS"
            optionLabel="label"
            optionValue="value"
            defaultLabel="Select connections...">
            <!-- (onChange)="updateConfiguration()" -->
          </p-multiSelect>
        </div>
      </div>
    </ng-container>
  }
</ng-template>

<ng-template #leftActionArea>
  <p-button [label]="CANCEL_LABEL" severity="secondary" styleClass="mr-2" (onClick)="getConfigurationData()" />
  <div [pTooltip]="!isValidLicense() ? INACTIVE_LICENSE : ''" tooltipPosition="bottom" appendTo="body">
    <p-button [label]="SAVE_CHANGES_LABEL" severity="success" [disabled]="!isValidLicense()" (onClick)="onSubmit()" />
  </div>
</ng-template>
